module.exports = __webpack_public_path__ + "static/media/jackpots-lvl0.bb7caf21.png";